import classnames from "classnames";
import { useQueryClient } from "react-query";
import { usePunditUserContext } from "@circle-react/contexts";
import { useNotificationWebSocket } from "@circle-react/hooks/notifications/useNotificationWebSocket";
import { PopoverPortal } from "@circle-react-uikit/PopoverPortal";
import { DEFAULT_POPPER_OPTIONS } from "../constants";
import { Body } from "./Body";
import { Header } from "./Header";
import { useNotificationContext } from "./NotificationContext";
import { NotificationPopoverButton } from "./NotificationPopoverButton";
import {
  useNotificationsCount,
  useResetNotificationCount,
} from "./useHeaderNotificationsApi";
import { onNotificationReceive } from "./utils";

export const NotificationPopover = () => {
  const {
    notificationCount,
    setNotificationCount,
    setNotificationTabCounters,
  } = useNotificationContext();

  const queryClient = useQueryClient();
  const { currentCommunityMember, currentCommunity, isViewOnlyMasquerading } =
    usePunditUserContext();

  useNotificationsCount(currentCommunity?.id, setNotificationTabCounters);
  const { mutate: resetNotificationCount } =
    useResetNotificationCount(setNotificationCount);

  useNotificationWebSocket(
    currentCommunityMember?.id as number,
    (eventData: any) =>
      onNotificationReceive({ eventData, queryClient, setNotificationCount }),
  );

  const handleNotificationPopoverOpen = () => {
    if (notificationCount > 0) resetNotificationCount();
  };

  return (
    <PopoverPortal
      renderButton={isOpen => (
        <NotificationPopoverButton
          isOpen={isOpen}
          notificationCount={notificationCount}
        />
      )}
      className={classnames(
        "border-primary bg-primary h-full max-h-[38rem] w-fit max-w-[35rem] rounded-lg border shadow-lg",
        {
          "cursor-not-allowed": isViewOnlyMasquerading,
        },
      )}
      onOpen={handleNotificationPopoverOpen}
      popperOptions={DEFAULT_POPPER_OPTIONS}
      shouldHideOnMdScreens={false}
    >
      <div
        className={classnames("h-full w-fit", {
          "pointer-events-none": isViewOnlyMasquerading,
        })}
        data-testid="notifications-drawer"
      >
        <Header />
        <Body />
      </div>
    </PopoverPortal>
  );
};
